import { call, put, all, takeEvery, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";

import {
  GET_SURVEY_STRUCTURE_COMPLIANCES,
  SG_GET_SURVEY_STRUCTURE_COMPLIANCES,
  SURVEY_STRUCTURE_COMPLIANCE_SELECT,
  SG_SURVEY_STRUCTURE_COMPLIANCE_SELECT,
  FETCH_SURVEY_STRUCTURE_COMPLIANCE,
  SG_FETCH_SURVEY_STRUCTURE_COMPLIANCE,
  EDIT_SURVEY_STRUCTURE_COMPLIANCE,
  SG_EDIT_SURVEY_STRUCTURE_COMPLIANCE,
  ADD_SURVEY_STRUCTURE_COMPLIANCE,
  SG_ADD_SURVEY_STRUCTURE_COMPLIANCE,
  DELETE_SURVEY_STRUCTURE_COMPLIANCE,
  SG_DELETE_SURVEY_STRUCTURE_COMPLIANCE,
  ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";

function* loadmethods(action) {
  //   yield put({ type: GET_methodS_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_SURVEY_STRUCTURE_COMPLIANCES, action.payload);
    // console.log(json.data)
    yield put({ type: GET_SURVEY_STRUCTURE_COMPLIANCES, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodLoad() {
  yield takeLatest(SG_GET_SURVEY_STRUCTURE_COMPLIANCES, loadmethods);
}

function* loadSelect(action) {
  //   yield put({ type: GET_methodS_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_SURVEY_STRUCTURE_COMPLIANCE_SELECT, action.payload);
    // console.log(json.data)
    yield put({ type: SURVEY_STRUCTURE_COMPLIANCE_SELECT, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* selectLoad() {
  yield takeLatest(SG_SURVEY_STRUCTURE_COMPLIANCE_SELECT, loadSelect);
}

function* fetchmethods(action) {
  try {
    const json = yield call(api.FETCH_SURVEY_STRUCTURE_COMPLIANCE, action.payload);
    yield put({ type: FETCH_SURVEY_STRUCTURE_COMPLIANCE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_SURVEY_STRUCTURE_COMPLIANCE, fetchmethods);
}



function* updatemethods(action) {
  try {
    const json = yield call(api.EDIT_SURVEY_STRUCTURE_COMPLIANCE, action.payload);
    yield put({ type: EDIT_SURVEY_STRUCTURE_COMPLIANCE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodUpdate() {
  yield takeEvery(SG_EDIT_SURVEY_STRUCTURE_COMPLIANCE, updatemethods);
}

function* addmethods(action) {
  // RESET_ADD_ACTIVE_PAGE_DEBRIEF_SCHEDULE
  try {
    const json = yield call(api.ADD_SURVEY_STRUCTURE_COMPLIANCE, action.payload);
    yield put({ type: ADD_SURVEY_STRUCTURE_COMPLIANCE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_SURVEY_STRUCTURE_COMPLIANCE, addmethods);
}

function* deletemethods(action) {
  try {
    yield call(api.DELETE_SURVEY_STRUCTURE_COMPLIANCE, action.payload);
    yield put({ type: DELETE_SURVEY_STRUCTURE_COMPLIANCE, payload: action.payload });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_SURVEY_STRUCTURE_COMPLIANCE, deletemethods);
}


export default function* index() {
  yield all([
    methodLoad(),
    methodFetch(),
    selectLoad(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
